export const siteDetails = {
    siteName: 'Niftipay',
    siteUrl: 'https://www.niftipay.com/',
    metadata: {
        title: 'Niftipay — Structured payment infrastructure for complex commerce',
        description: 'Unified card, crypto, and stablecoin acceptance through embedded payment infrastructure designed for bot and web-based commerce environments.',
    },
    language: 'en-us',
    locale: 'en-US',
    siteLogo: `${process.env.BASE_PATH || ''}/images/logo.png`, // or use a string for the logo e.g. "TechStartup"
    googleAnalyticsId: 'G-X6Q4JNBLWT', // e.g. G-XXXXXXX,
    hubspotPortalId: '148130526', // EU data centre (js-eu1); loaded only with analytics consent
}